import React from "react";
import { Navbar, Footer } from "./LandingPage/Components";

const LegalPage = ({ title, updated, lead, contactTitle, children }) => {
  const year = new Date().getFullYear();

  return (
    <div className="legal-page">
      <Navbar />
      <main className="legal-page__main">
        <header className="legal-page__hero">
          <p className="legal-page__label">Legal</p>
          <h1>{title}</h1>
          <p className="legal-page__updated">Last updated {updated}</p>
          <p className="legal-page__lead">{lead}</p>
        </header>

        <article className="legal-page__body">{children}</article>

        <section className="legal-page__contact" aria-labelledby="legal-contact-title">
          <h2 id="legal-contact-title">{contactTitle}</h2>
          <p className="legal-page__contact-name">JB Media LLC</p>
          <p>Operator of MeetOcto</p>
          <p>
            Email: <a href="mailto:info@meetocto.com">info@meetocto.com</a>
          </p>
          <p>
            Website:{" "}
            <a href="https://meetocto.com" target="_blank" rel="noopener noreferrer">
              https://meetocto.com
            </a>
          </p>
        </section>

        <p className="legal-page__copy">
          © {year} MeetOcto. A JB Media LLC company. All Rights Reserved.
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
